import { IconBold } from '@xingternal/icons';
import {
  toggleMark,
  isMarkActive,
  isBlockActive,
  BOLD_DEFINITIONS,
} from '@xingternal/content-editor-plugin-helpers';

const buttonConfig = ({
  disabledForBlockTypes = [],
  icon = IconBold,
  label = 'Bold',
  ...props
} = {}) => ({
  isHighlighted: (editor) => isMarkActive(editor, BOLD_DEFINITIONS.type),
  isDisabled: (editor) =>
    disabledForBlockTypes.some((element) => isBlockActive(editor, element)),
  icon,
  label,
  onClick: (event, editor) => {
    event.preventDefault();
    toggleMark(editor, BOLD_DEFINITIONS.type);
  },
  ...props,
});

export { buttonConfig };
